/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FacilitySettingValue
 */
export interface FacilitySettingValue {
    /**
     * 
     */
    facility_id: string;
    /**
     * 
     */
    setting_name: string;
    /**
     * 
     */
    value: string;
}

/**
 * Check if a given object implements the FacilitySettingValue interface.
 */
export function instanceOfFacilitySettingValue(value: object): value is FacilitySettingValue {
    if (!('facility_id' in value) || value['facility_id'] === undefined) return false;
    if (!('setting_name' in value) || value['setting_name'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function FacilitySettingValueFromJSON(json: any): FacilitySettingValue {
    return FacilitySettingValueFromJSONTyped(json, false);
}

export function FacilitySettingValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacilitySettingValue {
    if (json == null) {
        return json;
    }
    return {
        
        'facility_id': json['facility_id'],
        'setting_name': json['setting_name'],
        'value': json['value'],
    };
}

export function FacilitySettingValueToJSON(json: any): FacilitySettingValue {
    return FacilitySettingValueToJSONTyped(json, false);
}

export function FacilitySettingValueToJSONTyped(value?: FacilitySettingValue | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'facility_id': value['facility_id'],
        'setting_name': value['setting_name'],
        'value': value['value'],
    };
}

